<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12 container">
            <div class="col-xs-12 col-lg-12">
                <div v-for="(item, index) in current.itens" :key="index" class="row container-collapse">
                    <div class="col-xs-12 col-lg-12" @click="show_detail = !show_detail">
                        <div class="container-collapse-header">
                            <span><b>Item {{ item.id }}</b></span>
                            <span class="collapse-header-arrow" v-if="show_detail"><i class="fa fa-chevron-up"></i></span>
                            <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                        </div>
                    </div>
                    <div v-show="show_detail" class="col-xs-12 col-lg-12 container-collapse-body">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td><b>Código</b></td>
                                    <td>{{ item.code }}</td>
                                </tr>
                                <tr>
                                    <td><b>Descrição</b></td>
                                    <td>{{ item.description }}</td>
                                </tr>
                                <tr>
                                    <td><b>Quantidade</b></td>
                                    <td>{{ item.quantity }}</td>
                                </tr>
                                <tr>
                                    <td><b>Unidade</b></td>
                                    <td>{{ item.unit }}</td>
                                </tr>
                                <tr>
                                    <td><b>Valor</b></td>
                                    <td>{{ getMoney(item.amount) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "DeliveryItem",

	props: {
        current: {
            type: Object,
            require: true,
        },
    },

	data: function() {
		return {
			loading: false,
            show_detail: true,
		}
	},

	methods: {
        // Formata o valor em dinheiro
		getMoney: function(money) {
			let moneyAux = money.replace(",", ".").split(".");
			if(moneyAux.length > 1) {
				if (moneyAux[1].length > 1) {
					return "R$ " + moneyAux[0] + "," + moneyAux[1];
				} else {
					return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";
				}
			} else {
				return "R$ " + moneyAux[0] + ",00";
			}
		},
	}
}
</script>

<style scoped>
    .container {
        margin-top: 15px;
    }

    .container-collapse {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 15px;
    }

    .container-collapse-header {
        cursor: pointer;
    }

    span.collapse-header-arrow {
        float: right;
    }

    table { 
        margin-top: 15px;
        width: 100%;
        border-collapse: collapse;
    }

    thead > tr > th {
        text-align: center;
    }

    tr:nth-of-type(odd) { 
        background: #eee; 
    }

    th { 
        background: #ccc;
        font-weight: bold; 
    }

    td, th { 
        padding: 10px; 
        border: 1px solid #ccc; 
        text-align: left; 
        font-size: 14px;
    }
</style>